import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_USER_PASSWORD } from '@/api/endpoints';

interface UpdatePasswordPayload {
  currentPassword: string;
  newPassword: string;
  newPasswordConfirmation: string;
}

export const useUpdatePassword = () => {
  const { mutateAsync: updatePassword, isPending } = useMutation({
    mutationFn: (payload: UpdatePasswordPayload) =>
      apiClient.post(API_USER_PASSWORD, payload),
  });

  return { updatePassword, isPending };
};
